<template>
    <div>
        <navbar :title="text_title"></navbar>
        <div>
            <van-field
                class="fieldinp"
                v-model="message"
                rows="1"
                autosize
                type="textarea"
                placeholder="请输入签名"
            />
        </div>

        <div class="trueclick" @click="trueclick">确认修改</div>
    </div>
</template>
<script>
import navbar from '../../components/Navbar'
import '@/assets/classmatter.css'
import http from '@/plugins/http.js'
import Vue from 'vue';
import { Search } from 'vant';
import { Toast } from 'vant';
import { Field } from 'vant';

Vue.use(Field);
Vue.use(Toast);
Vue.use(Search);
export default {
    components:{
        navbar
    },
    data(){
        return {
            text_title:'修改签名',
            nameval:'',
            message:'',
        }
    },
    mounted(){
       
        if (localStorage.getItem("userInfo")) {
          this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
          console.log(this.userInfo)
        }
        this.getuser();
    },
    methods:{
        getuser(){
            this.$http.post('api/user/get_user',
            {
                token: this.userInfo.token
            }
            )
            .then( item => {
                this.item = item.data.result
            })
        },
        trueclick(){
            this.$http.post('api/user/alterme',
              {
                token: this.userInfo.token,
                nicename: this.item.user_nicename,
                signature: this.message,
              }
            )
            .then( item => {
                this.item = item.data.msg
                Toast(this.item);
                this.$router.go(-1)
            })
        }
    }
}

</script>
<style scoped>
.fieldinp /deep/{
    margin: 60px auto;
}
.trueclick {
    width: 90%;
    margin: 45px auto;
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #FFF;
    background-color: #1989fa;
    border-radius: 45px;
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/pages/alterinfo/qianming.vue